export default function (state = {
    log_login: {search_string: '', list:{},list_pagination:{rpp:20,max_pages:0,total_rows:0,page:1}},
    log_controllers: {search_string: '', list:{},list_pagination:{rpp:20,max_pages:0,total_rows:0,page:1}},
}, action) {
    switch(action.type) {
        case 'LOG_LOGIN_UPDATE_SEARCH_STRING':
            state.log_login.search_string = action.value;
            return { ...state };
        case 'LOG_LOGIN_SEARCH':
            state.log_login.list = action.data.list;
            state.log_login.list_pagination = action.data.list_pagination;
            return { ...state };
        case 'LOG_LOGIN_RPP_CHANGED':
            state.log_login.list_pagination.rpp = action.value;
            return { ...state };
        case 'LOG_LOGIN_SET_PAGE':
            state.log_login.list_pagination.page = action.value;
            return { ...state };

        case 'LOG_CONTROLLERS_UPDATE_SEARCH_STRING':
            state.log_controllers.search_string = action.value;
            return { ...state };
        case 'LOG_CONTROLLERS_SEARCH':
            state.log_controllers.list = action.data.list;
            state.log_controllers.list_pagination = action.data.list_pagination;
            return { ...state };
        case 'LOG_CONTROLLERS_RPP_CHANGED':
            state.log_controllers.list_pagination.rpp = action.value;
            return { ...state };
        case 'LOG_CONTROLLERS_SET_PAGE':
            state.log_controllers.list_pagination.page = action.value;
            return { ...state };

        default:
            break;
    }
    return state;
}

